import { useCallback, useEffect, useState } from 'react';
import { getAppSettings } from '../network';

export const useAppSettings = (id?: string): [
  any | null,
  boolean,
  Error | null,
  (appId?: string) => void
] => {
  const [result, setResult] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(async (appId?: string) => {
    setIsLoading(true);
    setError(null);

    appId = appId || id;

    if (appId) {
      try {
        const response = await getAppSettings(appId);
        setResult(response);
      } catch (e) {
        if (e instanceof Error) {
          setError(e);
        } else {
          setError(new Error('Unknown error'));
        }
      }
    } else {
      setError(new Error('ID is not provided'));
    }

    setIsLoading(false);
  }, [id]);

  useEffect(() => {
    if (id) {
      request();
    }
  }, [request, id]);

  return [result, isLoading, error, request];
};
